{
  "en": {
    "dashboard": {
      "greetings": {
        "afternoon": "Good afternoon {first_name}",
        "evening": "Good evening {first_name}",
        "morning": "Good morning {first_name}",
        "night": "Good night {first_name}"
      },
      "titles": {
        "activityFeed": "Activity Feed",
        "assignedTasks": "My Tasks",
        "newsFeed": "News Feed",
        "ongoingTickets": "Ongoing",
        "openTickets": "Open",
        "tickets": "Conversations",
        "totalTickets": "All conversations",
        "unreadTickets": "Unread",
        "yourAssignedTickets": "Assigned to you"
      }
    }
  }
}
